import React, { useRef } from 'react';
import Layout from '../../Layout';
import { Image, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../css/service.css';

const services = [
    {
        id: '01',
        title: 'Road Construction & Maintenance',
        desc: 'Design, grading, and paving of access roads.',
    },
    {
        id: '02',
        title: 'Structural Engineering',
        desc: 'Construction of industrial buildings, reinforced concrete structures, and steel fabrication.',
    },
    {
        id: '03',
        title: 'Drainage & Water Management',
        desc: 'Stormwater drainage, erosion control, and wastewater systems.',
    },
    {
        id: '04',
        title: 'Building Construction & Renovation',
        desc: 'Office buildings, warehouses, and refurbishment projects.',
    },
    {
        id: '05',
        title: 'Earthworks & Site Preparation ',
        desc: 'Land clearing, excavation, and soil stabilization.',
    }
];

const CivilWorks = () => {
  const navigate = useNavigate();


  const navToPage =()=> {
    navigate('/contact-us');
 }

    const scrollRef = useRef(null);

    const scroll = (direction) => {
        console.log("i scrolled ", scrollRef.current)
        if (scrollRef.current) {
            const scrollAmount = scrollRef.current.offsetWidth * 0.6; // 60% of container width
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Layout>

            <section className='abt-container'>
                <div className='abt-header'>
                    <Image src="/civil.png" className="d-inline-block  img-fluid" alt="inovative" />

                    <div className='header-content'>
                        <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>Civil <br /> Works.</h1>
                        <button onClick={navToPage} className='cta wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Request Consultation →</button>
                    </div>

                </div>
            </section>

            <section className='child-container serv'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We provide comprehensive civil construction services tailored to the oil and gas industry.</h1>
            </section>


            <section className='info-container'>
                <div className="servflex">
                    <div className="">
                        <div className="serv-line" />
                    </div>

                    <div className=''>
                        <p className='servParagText wow animate__animated animate__fadeInDown' data-wow-duration='1.5s'>Our expertise covers infrastructure development, structural engineering, and maintenance, ensuring durability, safety, and efficiency.</p>
                        {/* <br className='hide' /> */}
                    </div>
                </div>
            </section>


            {/* <section className='info-container'>
                <div className='sectionTwo mt-5'>
                    <Image src="/fab.png" className="d-inline-block  img-fluid wow fadeInDown" data-wow-duration="0.5s" alt="inovative" />
                </div>

            </section> */}



            <section className='sectionThree'>
                <div className='serv-container'>
                    <div className='sectionIn'>
                        <div className='sevThreeOne'>
                            {/* <span className='parag'>Scope of Services</span> */}
                            <h1 className='wow animate__animated animate__fadeIn' data-wow-duration='1s' style={{ fontWeight: "200" }}>
                                SCOPE OF CIVIL WORKS</h1>
                        </div>
                        <div className='sevThreeTwo'>
                            <div className='d-flex gap-2'>
                                <div onClick={() => scroll('left')} className='social-handle'>
                                    <span>&larr;</span>
                                </div>
                                <div onClick={() => scroll('right')} className='social-handle'>
                                    <span>&rarr;</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cardParent" ref={scrollRef}>
                        {services.map((svc, i) => {

                            const [firstWord, ...restWords] = svc.title.split(' ');
                            const restTitle = restWords.join(' ');
                            const delay = (i * 0.5).toFixed(1) + 's';

                            return (
                                <div key={svc.id} className="servCard wow animate__animated animate__fadeInRight"
                                    data-wow-delay={delay}>
                                    <div className="servCardContent">
                                        <h3>
                                            {firstWord}
                                            <br />
                                            {restTitle}
                                        </h3>
                                        <p>{svc.desc}</p>
                                        <button onClick={navToPage} className="cta">Request Service →</button>

                                        <div className='dflex align-items-end'>
                                            <span className="servCardNumber">{svc.id}</span>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>

                </div>
            </section>



        </Layout>
    );
};

export default CivilWorks;